// @ts-nocheck
import { useCallback, useEffect, useState } from "react";

import { PageHeader } from "../../styles/components";
import AvisoCarregamento from "../../components/AvisoCarregamento";
import Header from "../../components/Header";
import api from "../../services/api";

import { CardEmissao } from "./CardEmissao";
import { ModalRequerimento } from "./ModalRequerimento";
import { Container, Content, Corpo, Pilulas, Grade } from "./styles";

// Aba Emissões: certidões que a CJ está emitindo para os pedidos do
// cliente (EMISSÃO PT no Airtable, via GET central/emissoes). A API já
// devolve na ordem: sua vez, com a gente, concluídas.
export function Emissoes() {
  const [emissoes, setEmissoes] = useState([]);
  // "carregando" | "ok" | "erro"
  const [carga, setCarga] = useState("carregando");
  const [comoAssinar, setComoAssinar] = useState(null);

  const carregar = useCallback(() => {
    setCarga("carregando");
    api
      .get("central/emissoes")
      .then((response) => {
        setEmissoes(response.data?.emissoes || []);
        setCarga("ok");
      })
      .catch(() => setCarga("erro"));
  }, []);

  useEffect(() => {
    carregar();
  }, [carregar]);

  // Depois de um envio a API devolve a emissão atualizada (null = saiu da lista).
  const atualizar = useCallback((id, atualizada) => {
    setEmissoes((lista) =>
      atualizada ? lista.map((e) => (e.id === id ? atualizada : e)) : lista.filter((e) => e.id !== id)
    );
  }, []);

  const contar = (vez) => emissoes.filter((e) => e.vez === vez).length;

  return (
    <Container>
      <Header />
      <PageHeader>
        <Content>
          <h1>Emissões</h1>
          <p>
            Aqui ficam as certidões que a Cidadania Já está emitindo para os seus pedidos. Quando uma certidão chega ao nosso
            escritório e é conferida, ela entra no seu processo e aparece como recebida no card do pedido.
          </p>
        </Content>
      </PageHeader>

      <Corpo>
        {carga !== "ok" ? (
          <AvisoCarregamento
            erro={carga === "erro"}
            textoCarregando="Carregando suas emissões…"
            textoErro="Não conseguimos carregar suas emissões agora. Confira sua internet e tente de novo."
            tentarDeNovo={carregar}
          />
        ) : emissoes.length === 0 ? (
          <AvisoCarregamento erro textoErro="Nenhuma certidão sendo emitida pela Cidadania Já nos seus pedidos." />
        ) : (
          <>
            <Pilulas>
              {contar("cliente") > 0 && (
                <span>
                  <i style={{ background: "var(--atencao-50)" }} />
                  {contar("cliente")} · Sua vez
                </span>
              )}
              {contar("equipe") > 0 && (
                <span>
                  <i style={{ background: "var(--principal-50)" }} />
                  {contar("equipe")} · Com a gente
                </span>
              )}
              {contar("concluida") > 0 && (
                <span>
                  <i style={{ background: "var(--cinza-70)" }} />
                  {contar("concluida")} · {contar("concluida") > 1 ? "Concluídas" : "Concluída"}
                </span>
              )}
            </Pilulas>
            <Grade>
              {emissoes.map((e) => (
                <CardEmissao key={e.id} emissao={e} onAtualizada={atualizar} onComoAssinar={setComoAssinar} />
              ))}
            </Grade>
          </>
        )}
      </Corpo>

      <ModalRequerimento emissao={comoAssinar} onClose={() => setComoAssinar(null)} />
    </Container>
  );
}
